import { useRef } from "react";
import Draggable, { DraggableEvent } from "react-draggable";
import ModalDialog, { ModalDialogProps } from "react-bootstrap/ModalDialog";

export interface DraggableModalDialogProps extends ModalDialogProps {}

const DraggableModal = ({ ...props }: DraggableModalDialogProps) => {
  const ref = useRef(null);
  const onDrag = (e: DraggableEvent) => {
    if (e instanceof MouseEvent) {
      // TODO: constrain to window bounds
    }
  };

  return (
    <Draggable nodeRef={ref} onDrag={onDrag} handle=".handle">
      <ModalDialog ref={ref} {...props} style={{ transition: "none" }} />
    </Draggable>
  );
};

export default DraggableModal;
